import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { renderMarkdownFile, renderMarkdown } from 'utils'
import StyleSheet from 'styles'
import sanitizeHtml from 'sanitize-html'

const defaultAllowedTags = [ 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
  'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div',
  'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre' ]

export class Markdown extends Component {
  static propTypes = {
    mdfile: PropTypes.any,
    mdtext: PropTypes.string,
    allowedTags: PropTypes.arrayOf(PropTypes.string),
    noStyling: PropTypes.bool
  }

  static defaultProps = {
    allowedTags: defaultAllowedTags
  }

  constructor(props){
    super(props)
    this.state = { body: '' }
  }

  componentDidUpdate(prevProps) {
    const { mdfile, mdtext } = prevProps
    if(mdfile !== this.props.mdfile || mdtext !== this.props.mdtext) {
      this.updateContentFromProps(this.props)
    }
  }

  componentDidMount = () => {
    this.updateContentFromProps(this.props)
  }

  updateContentFromProps = (newProps) => {
    if(newProps.mdfile) {
      renderMarkdownFile(newProps.mdfile).then(body => {
        this.setState({body})
      })
    } else if(newProps.mdtext) {
      const markdown = renderMarkdown(newProps.mdtext)
      this.setState({body: markdown})
    }
  }

  render = () => {
    const {allowedTags, noStyling} = this.props
    return (
      <span
        dangerouslySetInnerHTML={{__html: sanitizeHtml(this.state.body, {allowedTags})}}
        className={[this.props.className, !noStyling && styles.markdown].filter(c => c).join(' ')}
        style={this.props.styles}
      />
    )

  }
}

const styles = StyleSheet({
  markdown: {
    'span&': {
      fontWeight: 400,
      fontFamily: 'Montserrat,sans-serif',
      '& p, li': {
        marginTop: 0,
        fontSize: '14px',
        lineHeight: '1.5em',
      },
      '& li': {
        marginBottom: 5,
      },
      '& ol, ul': {
        paddingLeft: 25,
      },
      '& h1, h2, h3, h4': {
        padding: 0,
        marginTop: '2em',
        '&:first-child': {
          marginTop: 0,
        },
      },
      '& h1': {
        fontSize: '26px',
        lineHeight: '32px'
      },
      '& h2': {
        fontSize: '20px',
        marginTop: '2em',
      },
      '& h3': {
        fontSize: '16px',
        marginBottom: 5,
      },
      '& h4, h5, h6': {
        marginBottom: 4,
      },
      '& table': {
        width: '100%',
        border: '1px solid rgba(0,0,0,0.1)',
        borderRadius: 2,
        borderSpacing: 0,
        '& th': {
          backgroundColor: 'rgba(0,0,0,0.03)'
        },
        '& th, & td': {
          textAlign: 'left',
          padding: 16,
          borderBottom: '1px solid rgba(0,0,0,0.1)'
        },
        '& tbody tr:last-child td': {
          borderBottom: 'none',
        }
      }
    }
  }
})